// ======================================================================
// File Name       : DistributionReportContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React from 'react';
import { connect } from 'react-redux';
import DistributionReportSearch from '../../../components/report/distribution/DistributionReportSearch';
import DistributionReportList from '../../../components/report/distribution/DistributionReportList';
import * as distributionAction from '../../../actions/report/DistributionAction';
import ModalConductor from '../../../components/modal/ModalConductor';
import Header from '../../../components/Header';
import MessageSearch from '../../../components/MessageSearch';

class DistributionReportContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAllowShowSearchMessage: false,
    };
    this.dismissMessage = this.dismissMessage.bind(this);
    this.updateShowSearchMessageFlag = this.updateShowSearchMessageFlag.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  componentWillMount() {
    // search to return default data list
    const { dispatch } = this.props;
    dispatch(distributionAction.initDistributionReportList());
  }

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(distributionAction.resetDistributionReport());
  }

  componentWillReceiveProps(nextProps) {
    const { dispatch, distributionReport } = nextProps;
    const { distributionReportDetail } = distributionReport;
    const { updateResult } = distributionReportDetail;
    if (updateResult.reportList && updateResult.reportList.length > 0) {
      dispatch(distributionAction.searchDistributionReport());
    }
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  updateShowSearchMessageFlag(isAllowShowSearchMessage) {
    this.setState({ isAllowShowSearchMessage });
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  /**
   * Render function of component
   */
  render() {
    const { distributionReport } = this.props;
    const { distributionReportList } = distributionReport;
    const { distributionReportListResult, distributionReports } = distributionReportList;
    const { recordNum } = distributionReports;
    const { hoverIndex } = this.state;
    return (
      <div>
        <MessageSearch
          resultList={distributionReportListResult}
          recordNum={recordNum}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <DistributionReportSearch updateShowSearchMessageFlag={this.updateShowSearchMessageFlag.bind(this)} />
        <DistributionReportList
          recordNum={recordNum}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          hoverIndex={hoverIndex}
        />
        <ModalConductor />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { distributionReport } = state;
  return {
    distributionReport,
  };
};

export default connect(mapStateToProps)(DistributionReportContainer);
